<div class="sidenav-bar" [ngClass]="{'isdeviceNav': secondaryNav}">
    <div class="sidenav-header row">
        <div class="sidenav-menu col-2" [ngClass]="symposiums ? 'disable': ''" *ngIf="showHeader">
            <span *ngIf="!secondaryNav" (click)="toggleNav(true);navmenu.scrollTop=0">
                ☰
            </span>
            <span *ngIf="secondaryNav" (click)="toggleNav(false);navmenu.scrollTop=0">
                ×
            </span>
        </div>
        <div class="sidenav-label col-6" *ngIf="showHeader">
            <a>
                <span *ngIf="!isShowSearchBar">
                    <a *ngIf="!symposiums" href="/cinejoy">
                        cinejoy
                    </a>
                    <a *ngIf="symposiums" href="/">
                        <img src="assets/images/Creatics_MainLogoUpdateHoriz2_20170915.png" alt="home-page"
                          style="width: 135px; margin-top: -10px; margin-left: 7px; height: 55px;">
                    </a>
                </span>
                <span *ngIf="isShowSearchBar && !secondaryNav">
                    <input type="text" class="form-control" placeholder="search here..." id="web-searchbar"
                        [(ngModel)]="searchText" (input)="searchThis()">
                </span>
            </a>
        </div>
        <div class="sidenav-search col-2"
            *ngIf="router.url=='/cinejoy/showcase' || router.url=='/cinejoy/showcase/archive'">
            <span *ngIf="isShowSearchIcon" (click)="ShowSearchBar()">
                <img [src]="searchIcon" alt="search-icon" />
            </span>

            <span *ngIf="isShowXIcon" (click)="HideSearchBar()">
                x
            </span>
        </div>
        <div class="sidebar_cart col-2" *ngIf="!symposiums">
            <div *ngIf="router.url !='/cinejoy' && router.url !='/cinejoy/about' &&
            router.url !='/cinejoy/screening-parties'  &&
            router.url !='/cinejoy/screening-parties/join' &&
            router.url !='/cinejoy/screening-parties/host' &&
            router.url != '/cinejoy/screening-parties/host-guide' &&
            router.url !='/cinejoy/showcase'  &&
            router.url !='/cinejoy/showcase/archive'  &&
            router.url !='/cinejoy/showcase/emotion'  &&
            router.url !='/cinejoy/showcase/genre'  &&
            router.url !='/cinejoy/showcase/features'  &&
            router.url !='/cinejoy/showcase/shorts'  &&
            router.url !='/cinejoy/showcase/archive/emotion'  &&
            router.url !='/cinejoy/showcase/archive/genre'  &&
            router.url !='/cinejoy/showcase/archive/features'  &&
            router.url !='/cinejoy/all-awards'  &&
            router.url !='/cinejoy/showcase/archive/shorts'  &&
            router.url !='/symposiums/lineup' &&
            router.url !='/cinejoy/screening-parties/getting-started'" class="sidebar_cart"
                [ngClass]="router.isActive('/cinejoy/premiere/upcoming', false) || router.isActive('/cinejoy/premiere/lineup', false) || router.isActive('/cinejoy/premiere/more-info', false) ? 'hide_cart' : '' ">
                <app-shopping-cart></app-shopping-cart>
            </div>
        </div>
    </div>
    <div class="first-nav row" #navmenu>
        <div class="col-1 col-sm-2 d-md-none d-lg-block col-lg-2 col-xl-1">
            <span style="display: none;">&nbsp;</span>
        </div>
        <div class="col-11 col-sm-10 col-md-11 col-lg-10 g-0  marginLeft">
            <div class="nav-top" [ngClass]="symposiums ? 'mob-disable': ''">
                <div *ngIf="!secondaryNav">
                    <div style="display: inline-block;" class="primary-nav-header font-poppins-regular">
                        <ul>
                            <li><a [routerLink]="['/cinejoy/premiere/lineup']" routerLinkActive="active">Spotlights</a>
                            </li>
                            <li><a (click)="navigateToUpcoming()" [routerLink]="['/cinejoy/premiere/more-info/']"
                                    routerLinkActive="active">Spotlights</a></li>
                            <li><a [routerLink]="['/cinejoy/passport/']" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}"
                                    (click)="toggleNav(false);navmenu.scrollTop=0;">Passport</a></li>
                            <li><a [routerLink]="['/cinejoy/passport/community/']" routerLinkActive="active"
                                    (click)="toggleNav(false);navmenu.scrollTop=0;">Community Passports</a></li>
                            <li *ngIf="
                            router.url != '/cinejoy/showcase/movies' &&
                            router.url != '/cinejoy/showcase/movie-page' &&
                            router.url != '/cinejoy/showcase/emotion' &&
                            router.url != '/cinejoy/showcase/genre' &&
                            router.url != '/cinejoy/showcase/shorts' &&
                            router.url != '/cinejoy/showcase/features' &&
                            router.url != '/cinejoy/showcase/movie'
                          ">

                                <a *ngIf="router.url != '/cinejoy/showcase/archive' &&
                          router.url != '/cinejoy/showcase/archive/emotion' &&
                          router.url != '/cinejoy/showcase/archive/genre' &&
                          router.url != '/cinejoy/showcase/archive/shorts' &&
                          router.url != '/cinejoy/showcase/archive/features' " [routerLink]="['/cinejoy/showcase']"
                                    style="height: 0vh" routerLinkActive="active">Showcase</a>

                                <a *ngIf="router.url != '/showcase' &&
                          router.url != '/cinejoy/showcase/emotion' &&
                          router.url != '/cinejoy/showcase/genre' &&
                          router.url != '/cinejoy/showcase/shorts' &&
                          router.url != '/cinejoy/showcase/features' &&
                          router.url != '/cinejoy/showcase/archive/emotion' &&
                          router.url != '/cinejoy/showcase/archive/genre' &&
                          router.url != '/cinejoy/showcase/archive/shorts' &&
                          router.url != '/cinejoy/showcase/archive/features'"
                                    [routerLink]="['/cinejoy/showcase/archive']" style="height: 0vh;font-size: 21px;"
                                    routerLinkActive="active">Showcase Archive</a>
                            </li>
                            <li><a href="/cinejoy/screening-parties">Screening Parties</a></li>
                        </ul>
                    </div>
                    <div class="primary-nav-list">
                        <ng-container *ngTemplateOutlet="primaryNav">
                        </ng-container>
                    </div>
                </div>
                <div style="display: inline-block;" *ngIf="secondaryNav" class="sec-nav-list font-poppins-regular" [ngClass]="symposiums ? 'mob-disable': ''">
                    <ul>
                        <li
                            *ngIf="router.url !='/cinejoy/premiere/upcoming' && router.url !='/cinejoy/premiere/lineup' && router.url !='/cinejoy/premiere/more-info/' && router.url !='/cinejoy/showcase/archive' && router.url !='/cinejoy/showcase' && !router.url.includes('moviepage') && router.url !=='/cinejoy/passport' && router.url !== '/cinejoy/passport/community' ">
                            <a href="/cinejoy/about" routerLinkActive="active">About</a>
                        </li>
                        <li (click)="close()"><a [routerLink]="['/cinejoy/premiere/lineup']"
                                routerLinkActive="active">Spotlights</a></li>
                        <!-- <li *ngIf="router.url =='/cinejoy/premiere/lineup'"><a [routerLink]="['/cinejoy/premiere/upcoming']" routerLinkActive="active">Spotlights</a></li> -->
                        <li><a [routerLink]="['/cinejoy/showcase']" (click)="navigateToShowcase()"
                                routerLinkActive="active">Showcase</a></li>
                        <!-- <li><a href="/cinejoy/celebrations/home">Celebrations</a></li> -->
                        <li><a [routerLink]="['/cinejoy/screening-parties/']" routerLinkActive="active">Screening
                                Parties

                            </a></li>

                        <li
                            *ngIf="router.url !='/cinejoy/premiere/upcoming' && router.url !='/cinejoy/premiere/lineup' && router.url !='/cinejoy/premiere/more-info/' && router.url !='/cinejoy/showcase/archive' && router.url !='/cinejoy/showcase' && !router.url.includes('moviepage') && router.url !=='/cinejoy/passport' && router.url !== '/cinejoy/passport/community' && router.url !='/cinejoy/awards'">
                            <a href="/cinejoy/awards" routerLinkActive="active">Awards</a>
                        </li>
                        <!--  <li>
                            <ng-container *ngIf="isLoginButtonDisabled">

                                <div *ngIf="router.url !='/premiere/upcoming' && router.url !='/premiere/lineup' && router.url !='/premiere/more-info/' " class="signup-div" fxLayout="row">
                                    <a href="/signup">JOIN FREE/</a>
                                    <a href="/" style="margin-left:-15%;">LOGIN</a>
                                </div>
                            </ng-container>
                        </li>-->

                    </ul>
                </div>
                <div style="display: inline-block;" class="sec-nav-list font-poppins-regular"
                    *ngIf="(router.url === '/cinejoy/all-awards' || router.url === '/cinejoy/archive/all-awards') && !secondaryNav ">
                    <ul>
                        <li class="ml-3 mb-2">Awards</li>
                        <li class="mt-3" style="cursor: pointer;border-radius: 5px;"
                            [ngStyle]="awardsSelectedCategory == 0 ? {'background-color': '#D7BE69'} : {'background-color': 'transparent'}">
                            <a (click)="selectedCategoryEmit(0)" routerLinkActive="active">All</a>
                        </li>
                        <li style="cursor: pointer;border-radius: 5px;"
                            [ngStyle]="awardsSelectedCategory == 1? {'background-color': '#D7BE69'} : {'background-color': 'transparent'}">
                            <a (click)="selectedCategoryEmit(1)" routerLinkActive="active">Audience</a>
                        </li>
                        <li style="cursor: pointer;border-radius: 5px;"
                            [ngStyle]="awardsSelectedCategory == 2?{'background-color': '#D7BE69'} : {'background-color': 'transparent'}">
                            <a (click)="selectedCategoryEmit(2)" routerLinkActive="active">Jury</a>
                        </li>

                    </ul>
                </div>
            </div>
            <div class="nav-bottom font-poppins-regular">
                <div class="sidenav-routes">
                    <div *ngIf="!symposiums">

                        <div *ngIf="router.url !='/cinejoy' && router.url !='/cinejoy/about' &&
                    router.url != '/cinejoy/screening-parties'  &&
                    router.url != '/cinejoy/screening-parties/join' &&
                    router.url != '/cinejoy/screening-parties/host' &&
                    router.url != '/cinejoy/screening-parties/host-guide' &&
                    router.url != '/cinejoy/screening-parties/getting-started' &&
                    router.url != '/cinejoy/all-awards' &&
                    router.url != '/cinejoy/archive/all-awards'">

                            <a class="my-ticket" (click)="openMyTicket()" *ngIf="!symposiums">My Tickets</a>
                            <a *ngIf="secondaryNav" class="my-ticket" href="cinejoy/group-share-info-page">Group
                                sharing</a>

                        </div>

                 
                          <div class="passport" *ngIf="router.url != '/cinejoy/all-awards'">
                            <a [routerLink]="['/cinejoy/passport']" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}"
                                (click)="toggleNav(false);navmenu.scrollTop=0;">Passport</a>
                            <a [routerLink]="['/cinejoy/passport/community']" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}"
                                (click)="toggleNav(false);navmenu.scrollTop=0;">Community Passports</a>
                        </div>


                        <div *ngIf="router.url !='/cinejoy' && router.url !='/cinejoy/about' &&
                    router.url != '/cinejoy/screening-parties'  &&
                    router.url != '/cinejoy/cinejoy/screening-parties/join' &&
                    router.url != '/cinejoy/screening-parties/host' &&
                    router.url != '/cinejoy/screening-parties/host-guide' &&
                    router.url != '/cinejoy/screening-parties/getting-started'&&
                    router.url != '/cinejoy/all-awards'">

                            <a href="/cinejoy/how-to">How-To/Tks</a>
                            <a href="/cinejoy/awards" *ngIf="router.url !='/cinejoy/awards'">Awards</a>
                            <a href="/cinejoy/archive/awards" *ngIf="router.url !='/cinejoy/archive/awards' && router.url !='/cinejoy/archive/all-awards'">Awards
                                Archive</a>
                            <a *ngIf="router.url !='/cinejoy/awards'" href="/cinejoy/about">About</a>
                            <a *ngIf="router.url !='/cinejoy/awards'" [routerLink]="['/cinejoy/premiere/archive']"
                                class="showcase-archive" routerLinkActive="active">Spotlight Archive</a>
                            <a *ngIf="router.url !='/cinejoy/awards'" [routerLink]="['/cinejoy/showcase/archive']"
                                class="showcase-archive" (click)="navigateToShowcase()"
                                routerLinkActive="active">Showcase Archive</a>


                        </div>

                    </div>

                    <div *ngIf="symposiums" class="symposiums">
                        <a href="/picture-the-possibilities">PTP</a>
                        <a href="/picture-the-possibilities/ptp-circle">PTP Circle</a>
                        <a href="/hitmaker">Hitmaker</a>
                        <a href="/cinejoy">Cinejoy</a>
                        <a href="/about">About</a>
                        <a *ngIf="isLoginButtonDisabled" href="/login">SIGN IN</a>
                    </div>

                    <div style="margin-top: 20px;" *ngIf="!symposiums">
                        <a href="/">
                            <img src="assets/images/Creatics_MainLogoUpdateHoriz2_20170915.png" alt="home-page"
                                width="130px">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>